import React, { Component } from 'react'
import { postCampusInternship } from '../../action/jobs';
import PostAJob from '../../old_Components/Campus/PostInternship'
import Swal from 'sweetalert2';
export default class JobPosting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
        }
    }
    componentDidMount() {
       
    }
    onSubmit = (model) => {
        this.setState({ showLoader: true })
        postCampusInternship(model).then(res => {
            this.setState({ showLoader: false })
            if (res.status) {
                this.props.history.push('/dashboard')
                this.setState({ showLoader: false })
                Swal.fire({
                    icon: 'success',
                    text: res.result.message,
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: res.error,
                    timer: 5000,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: 'error',
                text: error,
                timer: 5000,
                showCancelButton: false,
                showConfirmButton: false
            })
        })
    }
    render() {  
        return (
            <React.Fragment>
                {  
                    <PostAJob
                        onSubmit={this.onSubmit}
                        showLoader={this.state.showLoader}
                    />}
            </React.Fragment>
        )
    }
}
